// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"3c61f2e7","365":"44b1ccc7","496":"c314c6ac","519":"687144da","548":"43e28fe0","669":"2b3a99d1","737":"a54125f0","758":"da6cef0a","865":"b0e327a1","953":"cc606c94"}[chunkId] + ".chunk.js";
};